import React, { useState } from "react";
import { Progress } from "antd";

import EllipsisWithTooltip from "react-ellipsis-with-tooltip";
import Styles from "./style/listItem.module.scss";
import { functionService } from "../../../../../../../lib/functions";
import StudentDetailsCardWithVideos from "../../../../modals/studentDetailsCardWithVideos";
import styled from "styled-components";
import { useParams } from "react-router-dom";
import CoffeeDropDown from "../../../../dropDown"
import { progressBarColor } from "../../../../../../../utils/commonFunctions";

const Heading = styled.p`
  color: #ff2c91;
  
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 21px;
  margin-top: 10px;
`;

const SkillName = styled.p`
  color: #1e2228;
  
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 21px;
`;

const SkillDetails = styled.p`
  color: #1e2228;
  
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 21px;
`;

const CardContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  border-radius: 8px;
  background: #ffffff;
  border: 1px solid #efeff0;
  boxshadow: 0px 4px 44px rgba(29, 37, 45, 0.03);
  border-radius: 12px;
  margin-top: 20px;
  margin-bottom: 25px;
  position: relative;
`;

const DetailsText = styled.p`
  
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  color: #939599;
  margin: 0;
  padding: 0 0 5px 0;
`;

const Center = ({ skillsList }) => (
  <div style={{width:"65%"}} className={Styles.center}>
    <Heading>Skill Proficiency</Heading>
    <div className={Styles.centerPart}>
      {skillsList?.map(({ skills, top_percentile, percentile }) => {
        return (
          <div style={{ width: "70%" }}>
            <SkillName>
              <EllipsisWithTooltip placement="bottom">
                {skills}
              </EllipsisWithTooltip>
            </SkillName>
            <Progress
              strokeColor={progressBarColor(percentile)}
              percent={percentile}
              showInfo={false}
            />
            <SkillDetails>Top {top_percentile}%</SkillDetails>
          </div>
        );
      })}
    </div>
  </div>
);

const Right = ({
  getCandidateDetails,
  candidateID,
  loading,
  resume,
  openShowDetailsModal,
  setOpenShowDetailsModal,
  setDataToShow,
  current_state,
  getShortlistedCandiate
}) => {
  const { recruiter_id, search_id } = useParams();
  const actionOptions = ["Download Resume"];

  const handleChange = async (item) => {
    switch (item.key) {
      case actionOptions[0]:
        window.open(resume);
        return;

      default:
        return null;
    }
  };

  
 return  <div style={{width:"12%"}} className={Styles.right}>
  <StudentDetailsCardWithVideos
      studentId={candidateID}
      recruiter_id={recruiter_id}
      theme={1}
      style={{ marginBottom: '20px', width: '100%' }}
    />
    <CoffeeDropDown
      label="Actions"
      optionsList={actionOptions}
      changeHandler={handleChange}
    />
  </div>
};

const Left = ({
  userImage,
  profileName,
  location,
  experience_month,
  experience_year,
  phone,
  email,
  downloadResume,profile_image,
  current_state,
  offer_accepted,
  offer_sent
}) => (
  <div  style={{width:"20%"}} className={Styles.left}>

    {
      offer_accepted && current_state == null ? 
        <img
          src="/accept-offer.svg"
          style={{ position: "absolute", left: "-23px", top: "-17px", zIndex: '10'}}
        />
      : offer_sent && current_state == null ? 
        <img
          src="/make-offer.svg"
          style={{ position: "absolute", left: "-23px", top: "-17px", zIndex: '10'}}
        />
      : current_state == "SHORTLIST" ? 
        <img
          src="/shortlist.svg"
          style={{ position: "absolute", left: "-23px", top: "-17px", zIndex: '10'}}
        /> 
      : current_state == "ROUND1_CLEARED" ? 
        <img
          src="/round1_cleared.svg"
          style={{ position: "absolute", left: "-23px", top: "-17px", zIndex: '10'}}
        />
       : current_state == "ROUND2_CLEARED" ? 
        <img
          src="/round2_cleared.svg"
          style={{ position: "absolute", left: "-23px", top: "-17px", zIndex: '10'}}
        />
       : current_state == "OFFER_REJECTED" ? 
        <img
          src="/offer_rejected.svg"
          style={{ position: "absolute", left: "-23px", top: "-17px", zIndex: '10'}}
        />
      : current_state == "JOINED" ? 
        <img
          src="/joined.svg"
          style={{ position: "absolute", left: "-23px", top: "-17px", zIndex: '10'}}
        />
       : current_state == "NOT_JOINED" ? 
        <img
          src="/not_joined.svg"
          style={{ position: "absolute", left: "-23px", top: "-17px", zIndex: '10'}}
        />
        : ''
      
    }

    <img
      src={profile_image}
      style={{ marginRight: "20px" }}
      className={`${Styles["image-inner"]} ${Styles.imageadjust}`}
    />
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "baseline",
        }}
      >
        <h3 className={Styles.name}>{profileName} </h3>
        &nbsp;
        <img
          style={{ cursor: "pointer" }}
          src="/downloadResume.svg"
          onClick={() => {
            downloadResume();
          }}
        />
      </div>
      {experience_year || experience_month ? (
        <DetailsText>
          {location && (
            <>
              <img src="/location.svg" style={{ marginRight: "5px" }} />
              {location} | &nbsp;
            </>
          )}
          {experience_year ? `${experience_year} yrs` : ""} &nbsp;
          {experience_month ? `${experience_month} mos` : ""}&nbsp;
          {experience_year || experience_month ? "exp." : ""}&nbsp;
        </DetailsText>
      ) : (
        ""
      )}
      <DetailsText>{phone}</DetailsText>
      <DetailsText>{email}</DetailsText>
    </div>
  </div>
);

const ListViewCard = ({
  location,
  experience_month,
  experience_year,
  userImage,
  studentId,
  candidateID,
  resume,
  profileName,
  emailId,
  phone,
  skills,
  setDataToShow,profile_image, current_state,getShortlistedCandiate,
  offer_accepted,
  offer_sent
}) => {
  const [openShowDetailsModal, setOpenShowDetailsModal] = useState(false);
  const [studentDetails, setStudentDetails] = useState({});
  const [videosAvailable, setVideosAvailable] = useState(false);
  const [loading, setLoading] = useState(false);

  const { recruiter_id } = useParams();
  const getCandidateDetails = async () => {
    setLoading(true);
    const { status, response } = await functionService.get(
      `recruiter/candidate-details/${recruiter_id}/${studentId}`
    );

    if (status) {
      setOpenShowDetailsModal(true);

      setStudentDetails(response?.data?.data[0]);
      setVideosAvailable(
        response?.data?.data[0]?.skillsdata?.filter(e=>e.screenrecording_url!=null).length > 0 ? true : false
      );
      setLoading(false);
    } else {
      setLoading(false);
    }
  };


  return (
    <>
      <CardContainer>
     
        <Left
        profile_image={profile_image}
          downloadResume={() => {
            window.open(resume);
          }}
          experience_month={experience_month}
          experience_year={experience_year}
          location={location}
          userImage={userImage}
          profileName={profileName}
          phone={phone}
          email={emailId}
          current_state={current_state}
          offer_accepted={offer_accepted}
          offer_sent={offer_sent}
        />
        <Center skillsList={skills}  />
        <Right
          candidateID={candidateID}
          recruiter_id={recruiter_id}
          setDataToShow={setDataToShow}
          getCandidateDetails={getCandidateDetails}
          loading={loading}
          resume={resume}
          current_state={current_state}
          getShortlistedCandiate={getShortlistedCandiate}
          setOpenShowDetailsModal = {setOpenShowDetailsModal}
          openShowDetailsModal = {openShowDetailsModal}
        />
      </CardContainer>
    </>
  );
};

export default ListViewCard;
